import formValidation from '../components/formValidation/formValidation';
import stickyNav from '../components/stickyNav';
import lightbox from '../components/lightbox';

export default {
  init() {
    formValidation.init();
    stickyNav.init();
    lightbox.init();
  },
  unload() {
    lightbox.unload();
  },
  reload() {
    formValidation.reload();
    stickyNav.init();
    lightbox.reload();
  },
};
